<div class="pagination-nav" *ngIf="offerId !== '0' && offerTypeIdsByEventList.length > 0">
  <button class="nav-btn" title="Previous" [disabled]="currentTypeIndex <= 0"  (click)="previousOffer()">
    <mat-icon>chevron_left</mat-icon>
    Previous
  </button>

  <div class="counter">
    {{ currentTypeIndex + 1 }} / {{ offerTypeIdsByEventList.length }}
  </div>

  <button  class="nav-btn" title="Next"
          [disabled]="currentTypeIndex >= offerTypeIdsByEventList.length - 1" (click)="nextOffer()">
    Next
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
<ng-container *ngIf="viewModel$ | async as viewModel">
  <ng-container *ngIf="viewModel.montageBuilderStatus==false">
     
    <div class="offer-main-section">
      <div class="offerMainDiv">
        <div class="headerWidth">
          <h1 class="headerMargin">Offer Management</h1>
             <ng-container *ngIf="viewModel?.event?.EventName">
            <h2 class="event-name" title="{{viewModel.event.EventName}}">{{viewModel.event.EventName}}
              <link href="#">
            </h2>
          </ng-container>
        </div>

        <!-- <div *ngIf="offerId !== '0'" flex="row" fxLayoutAlign="space-between" class="arrows" style="margin-left: 55%">
          <button class="nextButtons" title="Previous" [disabled]="currentTypeIndex <= 0"
            (click)="previousOffer()">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>

          <button class="nextButtons" title="Next"
            [disabled]="currentTypeIndex >= offerTypeIdsByEventList.length - 1" (click)="nextOffer()">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
        </div> -->
       

        
            <ng-container *ngIf="offer$ | async as offerCopy">
           
              <div class="offer-container ">
                <h3 class="offer-title" title={{offerCopy?.Detail?.Name}}> {{ offerCopy?.Detail?.Name }}</h3>
                <div class="offer-controls">
                  <button *ngIf="offerId !=='0' && canEdit() == true"
                    (click)="deleteRecord(offerCopy?.Detail?.OfferVariantName)" class="version" mat-button>
                    {{offerCopy.Detail?.OfferVariantName}}
                    <fa-icon *ngIf=" offerCopy?.Detail?.OfferVariantName !== 'Base'"
                      [icon]="['fas', 'trash']"></fa-icon></button>
                       <button (click)="navigateChildOffers()" mat-button type="button" color="accent"
                  *ngIf="offerId !=='0' && variantsCount > 1" class="variants-link">View All Variants ({{ variantsCount
                  }})</button>
                </div>
              </div>            
          </ng-container>
          <div class="offer-actions" style="margin-left: auto;" fxLayout="row" fxLayoutGap="10px" *ngIf="router.url.includes('details')">
            <button *ngIf="canEdit() && offerEditCanUndo" mat-raised-button type="button" color="accent" (click)="undo()">
              Undo
            </button>
            <button mat-stroked-button type="button" (click)="cancel()">
              <span *ngIf="!canEdit()">Close</span>
              <span *ngIf="canEdit()">Cancel</span>
            </button>
            <button *ngIf="canEdit()" mat-raised-button type="button" (click)="save()"
              color="accent" [disabled]="viewModel.offerValidState === false || isRun || isIACopyProcessing || isIACopyReviewPending">
              Save
            </button>
          </div>
      </div>

      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start start" fxLayoutGap="20px">
        <div fxFlex="20" fxFlex.lt-md="100">
       

          <ng-container>
            <div *ngIf="offerId !== '0'; else defaultImage" fxLayout="row wrap"
              fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
              <mat-card fxFlex="100" appearance="outlined" class="offer-details-card"
                *ngIf="offer$ | async as OfferDetails;">
                <mat-card-content *ngIf="OfferDetails && OfferDetails.Detail" fxLayout="column">
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <ng-container *ngIf="readOnlyMode != true">
                      <div fxFlex="70" fxFlex.lt-md="100">
                        <div class="header-card-actions field-with-previous-step-hint" *ngIf="offerId != '0'"
                          [ngStyle]="{'top': canEdit() ? '0': '17px'}"
                          [class.field--modified]="isPropertyModified('Status')">
                          <span [matMenuTriggerFor]="canEdit() ? statusmenu: null"
                            class="status-btns status {{OfferDetails.Detail.Status === '0' ? 'statusPENDING' :  'status' + OfferDetails.Detail.Status}}"
                            [class.field--modified]="isPropertyModified('Status')">
                            {{(OfferDetails.Detail.Status &&
                            OfferDetails.Detail.Status === '0') ? 'PENDING' :
                            OfferDetails.Detail.Status }} <mat-icon *ngIf="canEdit()"
                              class="icon">arrow_drop_down</mat-icon>
                          </span>
                          <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Status') as text">{{ text }}</div>
                        </div>
                        <mat-menu #statusmenu="matMenu" class="status-menu">
                          <button type="button" class="statusAPPROVED tab-status" mat-menu-item
                            (click)="updateTableStatus(2)"
                            [disabled]="OfferDetails.Detail.Status === 'APPROVED'">APPROVED</button>
                          <button type="button" mat-menu-item class="statusPENDING tab-status"
                            (click)="updateTableStatus(1)"
                            [disabled]="OfferDetails.Detail.Status === 'PENDING'">PENDING</button>
                          <button type="button" class="statusSUPPRESSED tab-status" mat-menu-item
                            (click)="updateTableStatus(3)"
                            [disabled]="OfferDetails.Detail.Status === 'SUPPRESSED'">SUPPRESSED</button>
                        </mat-menu>
                      </div>
                      <div fxFlex="15" fxFlex.lt-md="100">
                        <ng-container *ngIf="isIAEnabled && labelType == LabelType.OFFER && isOnOfferDetailsTab()">
                          <div class="ai_generate_btn">
                            <button *ngIf="showIAProcessingIcon(offerResponse)" mat-icon-button class="jai-inprogress" disabled>
                              <img src="./assets/images/offer-edit-ai.png" alt="Offer image" />
                            </button>
                            <button *ngIf="showIAInitialIcon(offerResponse)" mat-icon-button [matMenuTriggerFor]="menu">
                              <img src="./assets/images/offer-edit-ai.png" alt="Offer image" />
                            </button>
                            <mat-menu #menu="matMenu" xPosition="before" class="ai-generate">
                                <div fxLayout="row" class="ai-header">
                                  <span><img src="./assets/images/offer-edit-ai.png" alt="" /></span>
                                  <p>Generate</p>
                                  <span class="ml-135"><mat-icon>close</mat-icon></span>
                                </div>
                                <ng-container *ngIf="isCopyEnabled">
                                  <hr />
                                  <div style="padding:10px 15px;">
                                    <p>
                                      <img src="./assets/images/type-icon.png" alt="Type" />
                                      <span>
                                        <b class="p-5 blue-color">Add Copy</b>
                                        <button style="float: right;" mat-stroked-button type="button" (click)="onCopyRun()">Run</button>
                                      </span>
                                    </p>
                                    <p>Add Headline <br />and Body Copy.</p>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="isIAMontageEnabled">
                                  <hr />
                                  <div style="padding:10px 15px;">
                                    <p>
                                      <img src="./assets/images/img-icon.png" alt="Type" />
                                      <span>
                                        <b class="p-5 blue-color">Group Image</b>
                                        <button style="float: right;" mat-stroked-button type="button" (click)="onMontageRun()">Run</button>
                                      </span>
                                    </p>
                                    <p>Create a group image <br />with multiple products.</p>
                                  </div>
                                </ng-container>
                              </mat-menu>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <div fxFlex="15" fxFlex.lt-md="100">
                      <div class="comments">
                        <div *ngIf="OfferDetails?.CommentsCount" class="pr-30">
                          <div id={{OfferDetails.DomainId}} (click)="openCommentsDialog($event,OfferDetails)"
                            class="comment-dialog">

                            <i class="fa fa-comment font-15" aria-hidden="true"></i>
                            <span class="comments-count">{{OfferDetails?.CommentsCount}}</span>
                          </div>
                        </div>
                        <div *ngIf="OfferDetails?.CommentsCount==0" class="pr-30">
                          <span id={{OfferDetails.DomainId}} (click)="openCommentsDialog($event,OfferDetails)"
                            class="comment-dialog">
                            <i class="fa fa-comment-o font-15" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="offer-left-img-wrapper">
                    <div class="badge-image" *ngIf="OfferDetails.Badge">
                      <img [src]="OfferDetails.Badge | offerPreview: PreviewMode.Medium" alt="Badge" />
                    </div>
                    
                    <div class="offer-left-img" [class.montage-background]="offerResponse?.JAICreativeMontageId">
                      <ng-container
                        *ngIf="(labelType != LabelType.PROMO && OfferDetails.FacingAsset && OfferDetails.OfferTypeId) || (labelType == LabelType.PROMO && OfferDetails.FacingAsset)">
                        <div *ngIf="isPreviewLoading" class="image-placeholder">Loading...</div>
                        <img *ngIf="imageSrc" mat-card-md-image [src]="imageSrc" (load)="onImageLoad()" (error)="onImageError()" [class.hidden]="isPreviewLoading" alt="Offer image"
                          (click)="openPreviewDialog(OfferDetails.FacingAsset)" class="matCardImage preview-clickable" />
                          <div *ngIf="labelType == LabelType.OFFER && showMontage" mat-stroked-button type="button" class="edit-image-btn" (click)="goToNewMontageEditor()" class="btn-edit">Edit Image</div> 
                      </ng-container>
                    </div>
                  </div>

                  <img mat-card-md-image
                    *ngIf="(labelType != LabelType.PROMO && !OfferDetails.FacingAsset?.FileName &&  (offerId == '0' || OfferDetails.OfferTypeId)) || (labelType == LabelType.PROMO && !OfferDetails.FacingAsset)"
                    [src]="imageSrc" (load)="onImageLoad()" (error)="onImageError()" alt="Offer image" class="matCardImage" />

                  <ng-container *ngIf="pricingPreviewHtml && !previewInfo" >
                    <div class="offer-preview-html"
                      [class.preview-field-modified--headline]="isPreviewFieldModified('Headline')"
                      [class.preview-field-modified--bodycopy]="isPreviewFieldModified('BodyCopy')"
                      [innerHtml]="isPreviewLoading ? '' : pricingPreviewHtml"></div>
                  </ng-container>
                  <ng-container *ngIf="offerId != '0' && !OfferDetails.OfferTypeId && labelType != LabelType.PROMO">
                    <img mat-card-md-image src="./assets/images/default-offer-image.png" alt="Offer image"
                      class="matCardImage" />
                    <div *ngIf="labelType == LabelType.OFFER" mat-stroked-button type="button" class="edit-image-btn" (click)="goToNewMontageEditor()" class="btn-edit">Edit Image</div> 
                    <div class="offer-type">Please select an offer type</div>
                  </ng-container>

                  <div *ngIf="previewInfo" class="runProcess">
                    <div [innerHtml]="previewInfo"></div>
                  </div>
                </mat-card-content>
              </mat-card>

              <div class="show-changes-toggle" *ngIf="awDetails != null && activeStageIndex >= 2" fxLayout="row" fxLayoutAlign="start center">
                <mat-slide-toggle
                  [checked]="showChangesFromPreviousStep"
                  (change)="onShowChangesFromPreviousStepChange($event.checked)"
                  aria-label="Show Changes from Previous Step">
                  Show Changes from Previous Step
                </mat-slide-toggle>
              </div>

              <ng-container *ngIf="labelType != LabelType.OFFERGROUP && readOnlyMode != true && canEdit()">
                <button [disabled]="disableNewVersion" (click)="openDialog()" class="versionBtn" mat-stroked-button
                  type="button" color="accent">
                  <fa-icon [icon]="['fas', 'copy']"></fa-icon>New Variant
                </button>

                <mat-form-field appearance="outline" class="headerMargin">
                  <mat-label>Offer Variant Name*</mat-label>
                  <mat-select [formControl]="newVersionName" (selectionChange)="getSelectedVersionDetail($event)">
                    <mat-option *ngFor="let variant of variantsList" [value]="variant">
                      {{variant.OfferVariantName}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="activeNavItem !== 'versions' && variantsCount > 1">
                  <mat-checkbox [disabled]="disableNewVersion" [formControl]="applyChanges">
                    Apply changes to multiple variants?
                  </mat-checkbox>
                </div>

                <mat-form-field *ngIf="activeNavItem !== 'versions' && variantsCount > 1 && applyChanges.value"
                  appearance="outline">
                  <mat-label>Apply Changes To*</mat-label>
                  <mat-chip-grid #chipList aria-label="Versions selection" [formControl]="VersionCtrl">
                    <ng-container *ngIf="offerserv.selection.selected.length !== variantsList.length">
                      <mat-chip-row *ngFor="let selectedVersion of offerserv.selection.selected"
                        [disabled]="newVersionName.value.Id === selectedVersion.Id"
                        (removed)="removeTag(selectedVersion)">
                        {{selectedVersion.OfferVariantName}}
                        <button type="button" matChipRemove>
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                    </ng-container>

                    <mat-chip-row *ngIf="offerserv.selection.selected.length === variantsList.length">
                      All Variants
                    </mat-chip-row>
                    <input placeholder="Select Variants..." [matChipInputFor]="chipList" [matAutocomplete]="auto"
                      [formControl]="VersionCtrl">
                  </mat-chip-grid>
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="tagSelected($event)">
                    <mat-option>
                      <mat-checkbox (click)="masterToggle()"
                        [checked]="offerserv.selection.hasValue() && isAllSelected()"
                        [indeterminate]="offerserv.selection.hasValue() && !isAllSelected()">
                        All Variants
                      </mat-checkbox>
                    </mat-option>
                    <mat-option *ngFor="let variant of variantsList" [value]="variant">
                      <mat-checkbox [disabled]="newVersionName.value.Id === variant.Id"
                        (click)="$event.stopPropagation()"
                        (change)="$event ? offerserv.selection.toggle(variant) : null"
                        [checked]="offerserv.selection.isSelected(variant)">
                        {{variant.OfferVariantName}}
                      </mat-checkbox>
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </ng-container>
            </div>
            <ng-template #defaultImage>
              <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
                <mat-card fxFlex="100" appearance="outlined">
                  <mat-card-content fxLayout="column">
                    <img src="./assets/images/default-image.png" alt="Offer image" class="offerImage matCardImage">
                  </mat-card-content>
                </mat-card>
              </div>
            </ng-template>
          </ng-container>
        </div>
        <div fxFlex="80" fxFlex.lt-md="100">
          
       
    <mat-card>
      <mat-card-content>
  <div [ngSwitch]="labelType">
            <nav *ngSwitchCase="LabelType.OFFER" mat-tab-nav-bar [tabPanel]="tabPanel">
              <a mat-tab-link [routerLink]="['details']" routerLinkActive #details="routerLinkActive"
                queryParamsHandling="preserve" [active]="details.isActive"
                (click)="setCurrentActiveItem('details')">Details
              </a>
              <a *ngIf="readOnlyMode != true" mat-tab-link [disabled]="offerId == '0' || offerserv.getNewVersion !== ''"
                [routerLink]="['products']" routerLinkActive queryParamsHandling="preserve" #products="routerLinkActive"
                [active]="products.isActive" [class.tab--modified]="isPreviewFieldModified('Product')"
                (click)="setCurrentActiveItem('products')">Products
                <span class="tab-modified-dot" *ngIf="isPreviewFieldModified('Product')"></span>
              </a>
              <a *ngIf="readOnlyMode != true" mat-tab-link [disabled]="offerId == '0' || offerserv.getNewVersion !== ''"
                [routerLink]="['versions']" routerLinkActive queryParamsHandling="preserve" #versions="routerLinkActive"
                [active]="versions.isActive" (click)="setCurrentActiveItem('versions')">Versions
              </a>
              <a *ngIf="readOnlyMode != true" mat-tab-link [disabled]="offerId == '0' || offerserv.getNewVersion !== ''"
                [routerLink]="['assets']" routerLinkActive queryParamsHandling="preserve" #assets="routerLinkActive"
                [active]="assets.isActive" [class.tab--modified]="isPreviewFieldModified('Asset')"
                (click)="setCurrentActiveItem('assets')">Assets
                <span class="tab-modified-dot" *ngIf="isPreviewFieldModified('Asset')"></span>
              </a>
              <a *ngIf="readOnlyMode != true" mat-tab-link [disabled]="offerId == '0' || offerserv.getNewVersion !== ''"
                [routerLink]="['activitylog']" routerLinkActive queryParamsHandling="preserve"
                #activitylog="routerLinkActive" [active]="activitylog.isActive"
                (click)="setCurrentActiveItem('activitylog')">Activity Log
              </a>
            </nav>
            <nav *ngSwitchCase="LabelType.PROMO" mat-tab-nav-bar [tabPanel]="tabPanel">
              <a mat-tab-link [routerLink]="['promodetails']" routerLinkActive #promodetails="routerLinkActive"
                queryParamsHandling="preserve" [active]="promodetails.isActive"
                (click)="setCurrentActiveItem('promodetails')">Promo Details
              </a>
              <a *ngIf="readOnlyMode != true" mat-tab-link [disabled]="offerId == '0' || offerserv.getNewVersion !== ''"
                [routerLink]="['versions']" routerLinkActive queryParamsHandling="preserve" #versions="routerLinkActive"
                [active]="versions.isActive" (click)="setCurrentActiveItem('versions')">Versions
              </a>
              <a *ngIf="readOnlyMode != true" mat-tab-link [disabled]="offerId == '0' || offerserv.getNewVersion !== ''"
                [routerLink]="['assets']" routerLinkActive queryParamsHandling="preserve" #assets="routerLinkActive"
                [active]="assets.isActive" [class.tab--modified]="isPreviewFieldModified('Asset')"
                (click)="setCurrentActiveItem('assets')">Assets
                <span class="tab-modified-dot" *ngIf="isPreviewFieldModified('Asset')"></span>
              </a>
              <a *ngIf="readOnlyMode != true" mat-tab-link [disabled]="offerId == '0' || offerserv.getNewVersion !== ''"
                [routerLink]="['activitylog']" routerLinkActive queryParamsHandling="preserve"
                #activitylog="routerLinkActive" [active]="activitylog.isActive"
                (click)="setCurrentActiveItem('activitylog')">Activity Log
              </a>
            </nav>
            <nav *ngSwitchCase="LabelType.OFFERGROUP" mat-tab-nav-bar [tabPanel]="tabPanel">
              <a mat-tab-link [routerLink]="['offergrpdetails']" routerLinkActive #offergrpdetails="routerLinkActive"
                queryParamsHandling="preserve" [active]="offergrpdetails.isActive"
                (click)="setCurrentActiveItem('offergrpdetails')">Details
              </a>
              <a *ngIf="readOnlyMode != true" mat-tab-link [disabled]="offerId == '0' || offerserv.getNewVersion !== ''"
                [routerLink]="['offers']" routerLinkActive queryParamsHandling="preserve" #offers="routerLinkActive"
                [active]="offers.isActive" (click)="setCurrentActiveItem('offers')">Offers
              </a>
              <a *ngIf="readOnlyMode != true" mat-tab-link [disabled]="offerId == '0' || offerserv.getNewVersion !== ''"
                [routerLink]="['versions']" routerLinkActive queryParamsHandling="preserve" #versions="routerLinkActive"
                [active]="versions.isActive" (click)="setCurrentActiveItem('versions')">Versions
              </a>
              <a *ngIf="readOnlyMode != true" mat-tab-link [disabled]="offerId == '0' || offerserv.getNewVersion !== ''"
                [routerLink]="['assets']" routerLinkActive queryParamsHandling="preserve" #assets="routerLinkActive"
                [active]="assets.isActive" (click)="setCurrentActiveItem('assets')">Assets
              </a>
            </nav>
          </div>
          <mat-tab-nav-panel #tabPanel>
            <router-outlet></router-outlet>
          </mat-tab-nav-panel>
      </mat-card-content>
    </mat-card>
        
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="viewModel.montageBuilderStatus==true">
    <app-new-montage-editor *ngIf="viewModel.useNewMontageEditor"></app-new-montage-editor>
    <app-montage-editor *ngIf="!viewModel.useNewMontageEditor"></app-montage-editor>
  </ng-container>
</ng-container>

<ng-template #loading>
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>
